function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "warning"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 8.013c-.553 0-1 .447-1 1v5c0 .553.447 1 1 1s1-.447 1-1v-5c0-.553-.447-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 16.013c-.26 0-.52.11-.71.29-.181.19-.29.45-.29.71s.109.52.29.71c.38.37 1.04.37 1.42 0 .18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.19-.18-.45-.29-.71-.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.534 16.992-6.796-13.011c-.909-1.738-2.105-1.998-2.738-1.998s-1.829.26-2.739 1.999l-6.794 13.009c-.652 1.247-.689 2.517-.104 3.484.586.969 1.73 1.525 3.137 1.525h13c1.407 0 2.551-.556 3.137-1.524s.549-2.238-.103-3.484zm-1.608 2.448c-.215.356-.736.56-1.426.56h-13c-.69 0-1.211-.204-1.426-.56-.216-.355-.155-.91.165-1.522l6.794-13.009c.358-.682.734-.926.967-.926s.609.243.966.925l6.796 13.011c.319.611.38 1.166.164 1.521z"
})));

var Svg130Warning = function Svg130Warning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg130Warning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/130-warning.680ff8fe.svg";
export { ForwardRef as ReactComponent };